import { ChangeDetectorRef, Component, OnInit, ViewChild } from '@angular/core';
import { ModalComponent } from 'angular-custom-modal';
import { firstValueFrom } from 'rxjs';
import { ModalContent } from '../../shared/modal-content';
import { CategoryData, GetCategoryRequestParams } from './categories.interface';
import { Router } from '@angular/router';
import { CategoriesService } from '../../services/categories/categories.service';
import { getOffset, showNotification } from '../../shared/helpers/helpers';
import { OptionItem } from '../../shared/types/api-responses.type';

@Component({
  selector: 'app-categories',
  templateUrl: './categories.component.html',
  styleUrls: ['./categories.component.css'],
})
export class CategoriesComponent implements OnInit {
  @ViewChild('modal') modal!: ModalComponent;

  loading = false;

  modalData: ModalContent = new ModalContent({
    header: 'Confirmation',
    body: 'Are you sure you want to delete this category?',
    showCloseButton: true,
    showConfirmButton: true,
    closeButtonLabel: 'Cancel',
    confirmButtonLabel: 'Delete',
    closeButtonClass: 'btn-secondary',
    confirmButtonClass: 'btn-danger',
  });

  selectedId = '';
  activeStatus: OptionItem[] = [];

  params = new GetCategoryRequestParams();
  totalRows = 0;

  cols = [
    { field: 'no', title: 'No' },
    { field: 'name', title: 'Name' },
    { field: 'code', title: 'Code' },
    { field: 'status_name', title: 'Status' },
    { field: 'created_at', title: 'Created At' },
    { field: 'updated_at', title: 'Updated At' },
    { field: 'created_by', title: 'Created By' },
    { field: 'action', title: 'Action', type: 'action' },
  ];

  pageSizeOptions = [5, 10, 25, 50, 100];
  rows: CategoryData[] = [];

  constructor(private cdRef: ChangeDetectorRef, private router: Router, private categoryService: CategoriesService) {}

  ngOnInit(): void {
    this.params.active = null;

    this.activeStatus = [
      {
        label: 'Active',
        value: '1',
      },
      {
        label: 'Inactive',
        value: '0',
      },
    ];
    this.getCategories().then();
  }

  async getCategories(): Promise<void> {
    this.loading = true;
    this.rows = [];

    try {
      const response = await firstValueFrom(this.categoryService.getCategoryService(this.params));
      this.rows = this.processDataForTable(response.data);
      this.totalRows = response.totalPage;
    } catch (error) {
      showNotification('error', 'Failed to fetch categories', JSON.stringify(error));
    } finally {
      this.loading = false;
    }
  }

  processDataForTable(data: CategoryData[]) {
    return data.map((each, i) => ({
      ...each,
      no: getOffset(this.params.pageNo, this.params.rowPerPage) + i + 1,
    }));
  }

  async changeServer(data: any): Promise<void> {
    this.params.pageNo = data.current_page;
    this.params.rowPerPage = data.pagesize;
    this.params.filter = data.search;
    await this.getCategories();
  }

  onInputChanged(value: string): void {
    console.log('Debounced Input:', value);
    this.params.filter = '';
    if (value) {
      this.params.filter = value;
    }
    this.cdRef.detectChanges();
  }

  goToForm(id: string): void {
    if (id === 'new') {
      this.router.navigate(['/categories/new']).then();
      return;
    }
    this.router.navigate(['/categories/edit', id]).then();
    return;
  }

  async deleteCategory(id: string): Promise<void> {
    this.loading = true;

    try {
      const delResp = await firstValueFrom(this.categoryService.deleteCategoryById(id));
      showNotification('success', 'Success to delete user', JSON.stringify(delResp));
      await this.getCategories();
    } catch (error) {
      showNotification('error', 'Failed to Delete categories', JSON.stringify(error));
    } finally {
      this.loading = false;
    }
  }

  async onModalDeleteConfirm(id: string): Promise<void> {
    await this.deleteCategory(id);
    this.modal.close();
  }

  async onStatusChange(statusOption: OptionItem): Promise<void> {
    this.params.active = null;
    if (statusOption) {
      this.params.active = statusOption.value;
    }
    await this.getCategories();
  }
}
